
   import { SelectionRepository } from '../../domain/repositories/SelectionRepository'
import { SelectionModel } from '../models/SelectionModel'

export class SelectionRepositoryImpl implements SelectionRepository {
 

  async getSelection(): Promise<SelectionModel | 'error'> {
    try {
      /// call api here like
      //   const otpRequestsFilterModel = new OtpRequestsFilterModel(filterData)
      // await OtpRequestsService.getOtpRequestsAdmin(otpRequestsFilterModel)
      const userModel = new SelectionModel({})

      return userModel
    } catch {
      return 'error'
    }
  }
}
